import assessmentReader from '../store/readHelpers/AssessmentReader';
import questionReader from '../store/readHelpers/QuestionReader';
import responseReader from '../store/readHelpers/ResponseReader';
import sessionReader from '../store/readHelpers/SessionReader';

const viewReadyTracker = {
    MESSAGE_VIEW_READY_SKIP: 'VIEW_READY: SKIP',
    MESSAGE_VIEW_READY_SUCCESS: 'VIEW_READY: SUCCESS',
    MESSAGE_VIEW_READY_ERROR: 'VIEW_READY: ERROR',

    setLocation(pathname, params) {
        this.pathname = pathname;
        this.logWhenReady = true;

        if (this.shouldReportSkip(params)) {
            this.logSkip();
            this.logWhenReady = false;
        }
    },

    reset() {
        if (this.loadTrackers) {
            this.killLoadTrackers(this.loadTrackers);
        }

        this.loadTrackers = [];
        return this;
    },

    registerLoadTracker(loadTracker) {
        if (loadTracker.getPathname() === this.pathname) {
            this.loadTrackers.push(loadTracker);
        }
    },

    killLoadTrackers(loadTrackers) {
        loadTrackers.forEach((tracker) => {
            tracker.kill();
        });
    },

    getReporter() {
        this.reset();
        return (success) => {
            this.reportReady(success, this.pathname);
        };
    },

    reportReady(success, pathname) {
        if (pathname !== this.pathname || !this.logWhenReady) {
            return undefined;
        }

        if (success) {
            return this.logSuccess();
        }

        return this.logError();
    },

    logSuccess() {
        window.console.log(this.MESSAGE_VIEW_READY_SUCCESS);
    },

    logError() {
        window.console.log(this.MESSAGE_VIEW_READY_ERROR);
    },

    logSkip() {
        window.console.log(this.MESSAGE_VIEW_READY_SKIP);
    },

    shouldReportSkip(params) {
        if (params.sectionId === undefined
            || !(sessionReader.isContextViewDelivery()
            || sessionReader.isContextViewDeliveryForAnnotationPdf())
        ) {
            return false;
        }

        let question;
        if (params.questionId) {
            question = assessmentReader.getQuestion(params.questionId);
        } else {
            question = assessmentReader.getStimulusForSectionId(params.sectionId);
        }

        if (!question) {
            return false;
        }

        return questionReader.isDocument(question)
            || questionReader.isOralQuestion(question)
            || !responseReader.isQuestionAttempted(question);
    },
};

export default viewReadyTracker;
